import { Splitter, SplitterOnChangeEvent } from '@progress/kendo-react-layout';
import { useEffect, useState } from 'react';
import SelectACompanyPlaceholder from 'src/components/SelectACompanyPlaceholder';

const useSplitter = (
  main: JSX.Element,
  preview: JSX.Element,
  showPreview: boolean,
  checkCompany = true
) => {
  const [panes, setPanes] = useState<Array<any>>([
    { size: '70%', min: '10%', scrollable: false },
    {},
  ]);

  const onChange = (event: SplitterOnChangeEvent) => {
    setPanes(event.newState);
  };

  useEffect(() => {
    if (showPreview) {
      setPanes([{ size: '68%', min: '10%', scrollable: false }, {}]);
    } else {
      setPanes([{ size: '100%', min: '10%', scrollable: false }, {}]);
    }
  }, [showPreview]);

  const content = (
    <Splitter className="overflow-hidden" panes={panes} onChange={onChange}>
      <div>{main}</div>
      <div>{preview}</div>
    </Splitter>
  );

  if (!checkCompany) {
    return content;
  }

  return <SelectACompanyPlaceholder display={content} />;
};

export default useSplitter;
